import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Document Icon
 *
 * @file Document.jsx
 * @author Kranthi Kiran Reddy Mattimadugu
 */

const Document = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 15 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26984 0.29716L14.1657 5.69706C14.3158 5.86212
        14.3992 6.077 14.3997 6.30005V15.7499L14.3997 15.7502C14.3847
        17.0076 13.3532 18.0148 12.0958 17.9998H2.30395L2.30363
        17.9998C1.0462 18.0147 0.0148193 17.0073 0
        15.7499V2.25012L3.85426e-06 2.2498C0.0150066 0.992361
        1.04652 -0.0148334 2.30396 0.000165365H8.60385C8.8578
        0.000765654 9.09969 0.108632 9.26984 0.29716ZM11.4645
        5.40012L8.9985 2.70017V4.63514L8.99764 4.64758C8.97397
        5.03953 9.27253 5.37646 9.66449 5.40012H11.4645ZM12.0958
        16.1999H2.30396C2.04097 16.2152 1.81536 16.0144 1.80005
        15.7514L1.79997 15.7499V2.25012C1.81443 1.98708 2.03939
        1.78557 2.30243 1.80004L2.30396 1.80013H7.19987V4.63508C7.16963
        6.01511 8.25902 7.16078 9.63883 7.20003H12.5998V15.7499C12.5853
        16.0129 12.3603 16.2144 12.0973 16.2L12.0958 16.1999ZM4.49992
        10.8H7.19987C7.69692 10.8 8.09985 10.397 8.09985 9.89999C8.09985
        9.40294 7.69692 9 7.19987 9H4.49992C4.00287 9 3.59993 9.40294 3.59993
        9.89999C3.59993 10.397 4.00287 10.8 4.49992 10.8ZM9.89982
        12.5999H4.49992C4.00287 12.5999 3.59993 13.0029 3.59993
        13.4999C3.59993 13.997 4.00287 14.3999 4.49992 14.3999H9.89982C10.3969
        14.3999 10.7998 13.997 10.7998 13.4999C10.7998 13.0029
        10.3969 12.5999 9.89982 12.5999Z"
      fill="currentcolor"
    />
  </SvgIcon>
);

export default Document;
